<template>
  <b-container>
    <tsny-modal
      :modal-id="modalId"
      :modal-title="'Edit Session Report'"
      :submit-button-text="'SUBMIT'"
      :submit-disabled="hasErrors"
      :reset-modal="resetModal"
      :submit-modal="submitForm"
    >
      <session-report-form
        ref="form"
        @update-errors="handleUpdateErrors"
        @form-data="updateSessionReport"
        :session-report="report"
        :action-error="updateSessionReportError"
        :action-error-text="updateSessionReportErrorText"
      />
    </tsny-modal>
  </b-container>
</template>

<script>
import TsnyModal from "../TsnyModal";
import SessionReportForm from "./SessionReportForm";
import EventBus from "../../services/eventBus/EventBus";
import EventConstants from "../../services/eventBus/EventConstants";
import CourseRelationshipRestService from "../../services/rest/services/CourseRelationshipRestService";

export default {
  name: "UpdateSessionReportModal",
  components: { TsnyModal, SessionReportForm },
  props: {
    id: {
      type: String,
      default: null
    },
    report: {
      type: Object,
      default: null
    }
  },
  computed: {},
  data: function() {
    return {
      modalId: "updateSessionReportModal",
      hasErrors: null,
      updateSessionReportError: null,
      updateSessionReportErrorText:
        "An error occurred editing the session report"
    };
  },
  methods: {
    resetModal() {
      this.hasErrors = null;
      this.updateSessionReportError = null;
    },
    handleUpdateErrors(valid) {
      this.hasErrors = !valid;
    },
    submitForm(bvModalEvent) {
      bvModalEvent.preventDefault();

      EventBus.$emit(EventConstants.EVENTS.SESSION_REPORT_FORM_SUBMISSION);
    },
    async updateSessionReport(formData) {
      let $comp = this,
        sessionReport = formData.sessionReport || {},
        isValid = await (formData.validationObserver || {}).validate();

      if (!isValid) return;

      return CourseRelationshipRestService.updateSessionReport(
        $comp.id,
        sessionReport
      )
        .then(() => {
          $comp.$bvModal.hide($comp.modalId);
        })
        .catch(err => {
          $comp.updateSessionReportError = true;
          console.log(err);
        });
    }
  }
};
</script>

<style scoped></style>
